// Polyfill for @near-js/crypto to work in browser
// This file ensures proper exports for CommonJS consumption

// Debug logging
console.log('Loading @near-js/crypto polyfill');

// Try different ways to import the module
let nearJsCrypto;
try {
  // Try to require from installed package
  nearJsCrypto = require('@near-js/crypto/lib/index.js');
  console.log('Loaded from @near-js/crypto/lib/index.js');
} catch (e1) {
  try {
    nearJsCrypto = require('@near-js/crypto');
    console.log('Loaded from @near-js/crypto');
  } catch (e2) {
    console.error('Failed to load @near-js/crypto:', e2);
    throw e2;
  }
}

console.log('nearJsCrypto:', nearJsCrypto);
console.log('PublicKey:', nearJsCrypto?.PublicKey);

// Re-export everything with proper structure
module.exports = {
  KeyType: nearJsCrypto.KeyType,
  KeyPair: nearJsCrypto.KeyPair,
  KeyPairEd25519: nearJsCrypto.KeyPairEd25519,
  PublicKey: nearJsCrypto.PublicKey,
  __esModule: true,
};

// Named exports for ES6 compatibility
module.exports.KeyType = nearJsCrypto.KeyType;
module.exports.KeyPair = nearJsCrypto.KeyPair;
module.exports.KeyPairEd25519 = nearJsCrypto.KeyPairEd25519;
module.exports.PublicKey = nearJsCrypto.PublicKey;

// Default export
module.exports.default = module.exports;

